import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Banner from "../../pages/banner";
import "./productDetails.css";

const ProductDetails = () => {
  const { id } = useParams();

  const products = [
    {
      id: "1",
      title: "Modern Sofa",
      description:
        "Experience ultimate comfort with our Modern Sofa. Crafted with premium fabric and a sturdy hardwood frame.",
      price: "25000",
      gallery: [
        { type: "image", url: "/images/sofa/sofa1.png" },
        { type: "image", url: "/images/sofa/sofa2.png" },
        { type: "image", url: "/images/sofa/sofa3.png" },
        { type: "image", url: "/images/sofa/sofa4.png" },
        {
          type: "video",
          url: "/videos/sofa-demo.mp4",
          poster: "/images/sofa/sofa1.png",
        },
      ],
    },
  ];

  const product = products.find((item) => item.id === id);
  const [selectedMedia, setSelectedMedia] = useState(product?.gallery[0]);

  // FAQ state
  const [activeFAQ, setActiveFAQ] = useState(null);

  const faqData = [
    "Do You Offer Customization Or Bulk Order Options?",
    "Can You Design Furniture Based On Our Brand Or Project Theme?",
    "Are All Materials Sustainably Sourced Or Certified?",
    "Do You Offer Catalog PDFs Or 3D Models For Design Presentations?",
    "Do You Have Quality Certifications (ISO, FSC, BSCI, Etc.)?",
  ];

  if (!product) return <h2>Product not found</h2>;

  const handleShare = async () => {
    const shareData = {
      title: product.title,
      text: "Check out this product!",
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(shareData.url);
        alert("Link copied to clipboard!");
      }
    } catch (err) {
      console.error("Share failed:", err);
    }
  };

  return (
    <div className="product-page-wrapper">
      <Banner
        title={product.title}
        subtitle="Product Details"
        height="150px"
      />

      <div className="amazon-container">
        {/* LEFT: Thumbnails */}
        <div className="thumb-col">
          {product.gallery.map((item, index) => (
            <div
              key={index}
              className={`thumb-box ${
                selectedMedia.url === item.url ? "active" : ""
              }`}
              onMouseEnter={() => setSelectedMedia(item)}
            >
              <img
                src={item.type === "video" ? item.poster : item.url}
                alt="preview"
              />
              {item.type === "video" && (
                <div className="video-badge">▶</div>
              )}
            </div>
          ))}
        </div>

        {/* MIDDLE: Main Preview */}
        <div className="main-view-col">
          <div className="main-preview-card">
            {selectedMedia.type === "video" ? (
              <video
                src={selectedMedia.url}
                autoPlay
                muted
                loop
                className="preview-media"
              />
            ) : (
              <img
                src={selectedMedia.url}
                alt="main-product"
                className="preview-media"
              />
            )}
          </div>
        </div>

        {/* RIGHT: FAQ SECTION */}
        <div className="info-col">
          <h1>{product.title}</h1>

          {/* Buttons Row */}
          <div className="action-row">
            <button className="btn btn-primary explore-btn">
              Send Enquiry
            </button>

            <button className="btn btn-secondary explore-btn share-btn" onClick={handleShare}>
              🔗 Share this Product
            </button>
          </div>

          <h2 className="faq-title">Frequently Asked Questions</h2>

          {faqData.map((question, index) => (
            <div key={index} className="faq-item">
              <div
                className="faq-question"
                onClick={() =>
                  setActiveFAQ(activeFAQ === index ? null : index)
                }
              >
                <span>{question}</span>
                <span
                  className={`arrow ${
                    activeFAQ === index ? "open" : ""
                  }`}
                >
                  ▼
                </span>
              </div>

              {activeFAQ === index && (
                <div className="faq-answer">
                  We provide complete support regarding this query. Please contact us for more details.
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

          {/* PRODUCT DETAILS SECTION */}

<div className=" container">

  <h2 className="details-title">
    Product Details
  </h2>

  <div className="details-content">

    <div className="detail-item">
      <span className="detail-label">Category</span>
      <span className="detail-value">Living Room Furniture</span>
    </div>

    <div className="detail-item">
      <span className="detail-label">Material</span>
      <span className="detail-value">
        Premium Fabric & Solid Wood
      </span>
    </div>

    <div className="detail-item">
      <span className="detail-label">Finish</span>
      <span className="detail-value">
        Matte Finish
      </span>
    </div>

    <div className="detail-item">
      <span className="detail-label">Color</span>
      <span className="detail-value">
        Customizable
      </span>
    </div>

    <div className="detail-item">
      <span className="detail-label">Dimensions</span>
      <span className="detail-value">
        Custom Sizes Available
      </span>
    </div>

    <div className="detail-item">
      <span className="detail-label">Usage</span>
      <span className="detail-value">
        Residential & Commercial
      </span>
    </div>

  </div>

  <p className="product-description">
    {product.description}
  </p>

</div>

    </div>
  );
};

export default ProductDetails;